import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.707 9.707a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 1 0 1.414 1.414zM9 8.002c.55 0 .998.447.998.998v1a.998.998 0 0 1-1.996 0V9c0-.551.447-.998.998-.998M15.998 14a.998.998 0 0 0-1.996 0v1a.998.998 0 0 0 1.996 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.09 2.319a4.76 4.76 0 0 0-6.18 0 2.76 2.76 0 0 1-1.571.65 4.76 4.76 0 0 0-4.37 4.37 2.76 2.76 0 0 1-.65 1.572 4.76 4.76 0 0 0 0 6.178c.377.443.605.993.65 1.572a4.76 4.76 0 0 0 4.37 4.369c.58.046 1.13.274 1.572.651a4.76 4.76 0 0 0 6.178 0 2.76 2.76 0 0 1 1.572-.651 4.76 4.76 0 0 0 4.369-4.369c.046-.58.274-1.13.651-1.572a4.76 4.76 0 0 0 0-6.178 2.76 2.76 0 0 1-.651-1.572 4.76 4.76 0 0 0-4.369-4.37 2.76 2.76 0 0 1-1.572-.65M10.207 3.84a2.76 2.76 0 0 1 3.584 0 4.76 4.76 0 0 0 2.71 1.123 2.76 2.76 0 0 1 2.534 2.534c.08.999.473 1.947 1.123 2.71a2.76 2.76 0 0 1 0 3.584 4.76 4.76 0 0 0-1.123 2.71 2.76 2.76 0 0 1-2.534 2.534c-.999.08-1.947.473-2.71 1.123a2.76 2.76 0 0 1-3.584 0 4.76 4.76 0 0 0-2.71-1.123 2.76 2.76 0 0 1-2.534-2.534c-.08-.999-.473-1.947-1.123-2.71a2.76 2.76 0 0 1 0-3.584 4.76 4.76 0 0 0 1.123-2.71 2.76 2.76 0 0 1 2.534-2.534c.999-.08 1.947-.473 2.71-1.123",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }